import { i18n } from 'lib/i18n.js';
import { decode } from 'utils/general';
import bus from 'lib/bus';

let i = 0;

export default {
  props: {
    products: { type: Array },
    accordionId: { type: String },
    accordionClass: { type: String },
    titleClass: { type: String },
    title: { type: String },
    contentClass: { type: String },
    content: { type: String },
    initiallyCollapsed: { type: Boolean, default: true },
  },
  i18n,
  data() {
    return {
      isActive: false,
      i: i++,
    };
  },
  mounted() {
    this.isActive = !this.initiallyCollapsed;
    bus.$on(`open-${this.accordionId}-accordion`, () => {
      this.isActive = true;
    });
  },
  computed: {
    isOpen() {
      if (!this.isActive) {
        return 'hidden';
      }
      return 'visible';
    },
    height() {
      if (!this.isActive) {
        return 0;
      }
      return 'unset';
    },
    openText() {
      return `${this.$t('general.actions.open')} ${this.title}`;
    },
    closeText() {
      return `${this.$t('general.actions.close')} ${this.title}`;
    },
    contentDecoded() {
      return decode(this.content);
    },
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive;

      this.$emit('toggle', this);
    },
    getVideoThumbnail(...args) {
      return this.$parent.getVideoThumbnail(...args);
    },
    openVideo(...args) {
      return this.$parent.openVideo(...args);
    },
  },
  template: `
  <div
    class="accordion"
    :id="[accordionId]"
    :class="[accordionClass, {'is-active': isActive}]">
    <div>
      <h2>
        <button
          class="accordion__title block w1 align-l relative"
          :class="title_class"
          @click="toggle"
          :aria-expanded="(isActive) ? 'true' : 'false'"
          :aria-controls="'accordion_' + i">
          {{ title }}
          <div class="accordion__title__icon">
          </div>
        </button>
      </h2>
      <div class="accordion__body" :style="{maxHeight: height, visibility: isOpen}" :id="'accordion_' + i">
        <div class="accordion__body__content" :class="contentClass" ref="content">
          <div v-if="content" v-html="contentDecoded"></div>
          <slot v-else></slot>
        </div>
      </div>
    </div>
  </div>
  `,
};
